import KitFadeView from '@omni/kit/components/KitFadeView';
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import PlayerButton, { PlayerButtonSizes } from './PlayerButton';

export interface GiveButtonProps {
  isVisible?: boolean;
  size?: PlayerButtonSizes;
  onGive: () => void;
}

export default function GiveButton({
  isVisible,
  size = PlayerButtonSizes.small,
  onGive,
}: GiveButtonProps): ReactElement {
  const { t } = useTranslation('common');

  return (
    <KitFadeView show={isVisible} keepElementSize>
      <PlayerButton
        size={size}
        icon='give'
        onPress={onGive}
        frameless
        tooltipProps={{
          position: 'bottom center',
          label: t('give'),
        }}
      />
    </KitFadeView>
  );
}
